import React from 'react';
import { StepProps } from '../MortgageApplicationPage';
import { 
    MultistepForm,
    SetSubmitError,
    SetIsLoading,
    InputType,
    FormStep
} from 'view/components/common';
import { 
    isRequired
} from 'core/utilities';
import { updateEmploymentInfo } from 'core/api';
import { useToast } from 'core/toast';

type FormValues = {
    self_employed : boolean;
    employer_name : string;
    years         : string;
    role          : string;
};

const formSteps = [
    [
        {
            type : InputType.text,
            name : 'employer_name',
            label : 'Where do you work?',
            placeholder : 'Company Name',
            required : true,
            validator : isRequired
        },
        {
            type : InputType.text,
            name : 'role',
            label : 'What is your job there?',
            placeholder : 'Software Engineer',
            required : true,
            validator : isRequired
        },
        {
            type : InputType.toggle,
            name : 'self_employed',
            label : 'Are you self employed'
        },
        {
            type : InputType.select,
            name : 'years',
            label : 'How long have you worked there?',
            placeholder : 'Less than 1',
            options : [
                { value : '0', label : 'Less than 1' },
                { value : '1', label : '1 year' },
                { value : '2', label : '2 years' },
                { value : '3', label : '3 years' },
                { value : '4', label : '4 years' },
                { value : '5', label : '5 or more years' }
            ]
        }
    ]
] as Array<FormStep>;

export const Employment : React.FunctionComponent<StepProps> = ({
    step, 
    setStep,
    progressForward,
    progressBackward,
    authState,
    application,
    complete
}) => 
{
    const { setToastMessage } = useToast();
    const onExit = () =>
    {
        setStep(s => s - 1);
        progressBackward();
    };

    const onSubmit = (_: SetSubmitError, setIsLoading : SetIsLoading) =>
    {
        return async (payload : FormValues) => 
        {
            setIsLoading(true);

            const employment = complete && complete.employment && complete.employment.length > 0 ? complete.employment[0] : {};
            const {
                success,
                error
            } = await updateEmploymentInfo(authState, {
                ...payload,
                applicationId : application.id,
                employmentId  : employment.id
            });

            if (success)
            {
                setTimeout(() =>
                {
                    setStep(s => s + 1);
                    progressForward();
                }, 1000);
            }
            else
            {
                setIsLoading(false);
                setToastMessage(error);
            }
        };
    };

    const employment = complete && complete.employment && complete.employment.length > 0 ? complete.employment[0] : {};
    const initialValues = {
        self_employed : employment.self_employed ?? false,
        employer_name : employment.employer_name ?? '',
        years         : employment.years ?? '',
        role          : employment.role ?? ''
    };

    return (
        <MultistepForm
            title='Employment Information'
            backText='Back'
            stepTitle={() => `Step ${step}`}
            onExit={onExit}
            initialValues={initialValues}
            formSteps={formSteps}
            onSubmit={onSubmit}
        />
    );
};